import { useEffect, useRef, useState } from "react";
import { getDefaultAgentImageSrc } from "../utils/defaultAgentImages";
import { getDefaultCTAVisual } from "../utils/defaultCTAVisuals";

export const useChatImageSource = (image: string | File) => {
  const [imageSrc, setImageSrc] = useState<string>();

  const urlRef = useRef<string | null>(null);

  useEffect(() => {
    const revokeObjectUrl = () => {
      if (urlRef.current) {
        URL.revokeObjectURL(urlRef.current);
        urlRef.current = null;
      }
    };

    if (image instanceof File) {
      revokeObjectUrl();
      const url = URL.createObjectURL(image);
      urlRef.current = url;
      setImageSrc(url);
      return revokeObjectUrl;
    }

    revokeObjectUrl();
    setImageSrc(image);
    return revokeObjectUrl;
  }, [image]);

  return imageSrc;
};

export const useAgentImageSource = (image: string | File) => {
  const [imageSrc, setImageSrc] = useState<string>();

  const urlRef = useRef<string | null>(null);

  useEffect(() => {
    const revokeObjectUrl = () => {
      if (urlRef.current) {
        URL.revokeObjectURL(urlRef.current);
        urlRef.current = null;
      }
    };

    if (image instanceof File) {
      revokeObjectUrl();
      const url = URL.createObjectURL(image);
      urlRef.current = url;
      setImageSrc(url);
      return revokeObjectUrl;
    }

    revokeObjectUrl();

    if (image.startsWith("default")) {
      setImageSrc(getDefaultAgentImageSrc(image));
    } else {
      setImageSrc(image);
    }

    return revokeObjectUrl;
  }, [image]);

  return imageSrc;
};

const isDefaultCTAVisualId = (value: string): boolean =>
  value.startsWith("default");

export const useCTAVisualSource = (
  visual: string | File | null
): string | null => {
  const [mediaSrc, setMediaSrc] = useState<string | null>(null);

  const urlRef = useRef<string | null>(null);

  useEffect(() => {
    const revokeObjectUrl = () => {
      if (urlRef.current) {
        URL.revokeObjectURL(urlRef.current);
        urlRef.current = null;
      }
    };

    if (!visual) {
      revokeObjectUrl();
      setMediaSrc(null);
      return revokeObjectUrl;
    }

    if (visual instanceof File) {
      revokeObjectUrl();
      const url = URL.createObjectURL(visual);
      urlRef.current = url;
      setMediaSrc(url);
      return revokeObjectUrl;
    }

    if (isDefaultCTAVisualId(visual)) {
      setMediaSrc(getDefaultCTAVisual(visual).src);
    } else {
      setMediaSrc(visual);
    }

    return revokeObjectUrl;
  }, [visual]);

  return mediaSrc;
};
